import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Hook para detectar breakpoints y medidas de pantalla usando MUI
 * @returns objeto con diferentes medidas de pantalla detectadas
 */
const useDevice = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
  const isScreenMedium = useMediaQuery(theme.breakpoints.only('md'));
  const hasHover = useMediaQuery('(hover: hover) and (pointer: fine)');

  return {
    isMobile,
    isTablet,
    isDesktop,
    isLargeScreen,
    isExtraLargeScreen,
    isScreenMedium,
    hasHover,
  };
};

export default useDevice;
